<template>
  <div>
    <br /><br /><br />
    <Packages />
    <Solutions v-if="false" />
    <Calltoaction v-if="false" />
    <VideoModal />
  </div>
</template>

<script>
import Solutions from "@/components/other-pages/sessions/Solutions";
import Packages from "@/components/other-pages/sessions/Packages";
import Calltoaction from "@/components/other-pages/sessions/Calltoaction";
import VideoModal from "@/components/other-pages/guide/VideoModal";
export default {
  components: {
    Solutions,
    Packages,
    Calltoaction,
    VideoModal
  }
};
</script>

<style lang="scss" scoped></style>
